
import Vue from 'vue'
import { VFileInput } from 'vuetify/lib'
import JcdcProgressLinear from '@/components/jcdc/JcdcProgressLinear.vue'

interface maxSize {
  size: number
  unit: string
}
export default Vue.extend({
  name: 'JcdcFileInput',
  components: {
    VFileInput,
    JcdcProgressLinear,
  },
  props: {
    label: { type: String, required: true },
    hint: { type: String, default: '' },
    dense: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    rules: {
      type: Array as () => Array<(v: string) => void>,
      default: (): [] => [],
    },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    errorMessage: { type: String, default: undefined },
    multiple: { type: Boolean, default: false },
    maxSize: { type: Object as () => maxSize, default: undefined },
    showSize: { type: Boolean, default: false },
  },
  data() {
    return {}
  },
  computed: {
    computedRules(): Array<(v: string) => void> {
      const ruleArray: Array<(v: string) => void> = [...this.rules]
      // REQUIRED
      if (this.required) {
        ruleArray.push((v: string | null) => {
          let value = v
          if (this.multiple) {
            value = v && v.length > 0 ? v : null
          }
          const test =
            Boolean(value) ||
            (this.errorMessage
              ? this.errorMessage
              : `${this.label} is required.`)
          return test
        })
      }
      // MAX SIZE
      if (this.maxSize) {
        ruleArray.push((v: unknown) => {
          let valid,
            invalidCount = 0
          // Multiple
          if (Array.isArray(v)) {
            const validArray = v.map((x) => {
              const valid = this.validateSize(x.size)
              !valid ? invalidCount++ : invalidCount
              return valid
            })
            valid = !validArray.includes(false)
          }
          // Single
          else {
            const x = v as File
            valid = v ? this.validateSize(x.size) : v
          }
          return (
            (v ? valid : !v) ||
            `${this.maxSizeHint}${
              invalidCount
                ? ` ${invalidCount} file${
                    invalidCount == 1 ? ' is' : 's are'
                  } too large.`
                : ''
            }`
          )
        })
      }
      return ruleArray
    },
    maxSizeHint(): string {
      return this.maxSize
        ? `File size${this.multiple ? 's' : ''} should be less than ${
            this.maxSize.size
          } ${this.maxSize.unit}.`
        : ''
    },
    computedHint(): string {
      return `${this.hint} ${this.maxSizeHint}`
    },
  },
  methods: {
    validateSize(size) {
      const multiple =
          this.maxSize.unit == 'KB'
            ? 1024
            : this.maxSize.unit == 'MB'
            ? 1024 * 1024
            : 1,
        maxsize = this.maxSize.size * multiple
      return size < maxsize
    },
  },
})
